import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';

import Img from '@src/components/Img';
import ImgNode from '@src/components/ImgNode';
import Tabs from '@src/components/ProfileTabs';
import GorkoLink from '@src/components/GorkoLink';
import Slider from '@src/components/UISliderSplide';

import useStyles from 'isomorphic-style-loader/useStyles';
import css from './style.module.sass';

const ProfileAlbumsFunc = (props) => {
	useStyles(css);
	const { tabsProps, imgs, desc, sliderKey, onClickImg } = props;

	return (
		<div className={css.group}>
			{tabsProps && <Tabs {...tabsProps} />}

			<div className={cn(css.wrap, { [css.wrap_desc]: !desc })}>
				<div className={css.media}>
					{!!imgs.length && (
						<Slider
							key={sliderKey}
							gap={4}
							shift={3}
							height={200}
							isElastic
						>
							{imgs.map((i, l) => {
								if (i.href) {
									return (
										<GorkoLink to={i.href} key={i.href}>
											<ImgNode img={i.img} />
										</GorkoLink>
									);
								}
								return (
									<a
										role="link"
										tabIndex={0}
										key={i.img.src}
										style={{
											cursor: onClickImg
												? 'pointer'
												: 'default',
										}}
										onClick={
											onClickImg
												? () => onClickImg(i, l)
												: undefined
										}
									>
										<ImgNode img={i.img} />
									</a>
								);
							})}
						</Slider>
					)}
				</div>

				{desc && (
					<p
						className={css.desc}
						// eslint-disable-next-line react/no-danger
						dangerouslySetInnerHTML={{ __html: desc }}
					/>
				)}
			</div>
		</div>
	);
};

ProfileAlbumsFunc.propTypes = {
	tabsProps: PropTypes.shape(Tabs.type.propTypes),
	imgs: PropTypes.arrayOf(
		PropTypes.shape({
			img: PropTypes.shape(Img.type.propTypes),
			href: PropTypes.string,
		}),
	),
	desc: PropTypes.string,
	sliderKey: PropTypes.string,
	onClickImg: PropTypes.func,
};

ProfileAlbumsFunc.defaultProps = {
	tabsProps: undefined,
	imgs: [],
	desc: undefined,
	sliderKey: undefined,
	onClickImg: undefined,
};

export default ProfileAlbumsFunc;
